import { ApiClientFactory } from '@/services/api/apiClientFactory.ts'

const twineServiceClient = ApiClientFactory.getInstance(`${window.location.origin}/`)

export { twineServiceClient }
